import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { toast } from 'react-toastify';
import { getToast } from '../../../utils/toastConfig';

function ModalADelete(props) {
    const {
        assetModalDeleteString,
        assetMDNameString,
        assetMDEquipString,
        assetMDSiteString,
        assetMDUDateString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteAssetName = localStorage.getItem("assetNameToDelete");
    var deleteAssetEquipName = localStorage.getItem("assetEquipNameToDelete");
    var deleteAssetUpdatedDate = localStorage.getItem("assetUpdatedDateToDelete");
    var deleteAssetClientSite = localStorage.getItem("assetClientSiteToDelete");

    var deleteAssetId = localStorage.getItem("assetIdToDelete");
    
    const deleteAsset = () => {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteAsset/${deleteAssetId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar equipo. Vuelve a intentarlo.' });
        });
    } 
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Equipo eliminado exitosamente en la base de datos.' });
        props.getAssets();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {assetModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{assetMDNameString}:</strong> {deleteAssetName}</span><br />
                <span className='delete-info'><strong>{assetMDEquipString}:</strong> {deleteAssetEquipName}</span><br />
                <span className='delete-info'><strong>{assetMDSiteString}:</strong> {deleteAssetClientSite}</span><br />
                <span className='delete-info'><strong>{assetMDUDateString}:</strong> {deleteAssetUpdatedDate}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteAsset()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalADelete;